"use client";

import { useEffect, useState } from "react";

import { colors } from "@/styles/design-tokens";

export interface ThinkingIndicatorProps {
  delay?: number;
}

export function ThinkingIndicator({ delay = 200 }: ThinkingIndicatorProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  if (!visible) {
    // Invisible placeholder to maintain layout
    return <div className="h-5 w-5 flex-shrink-0 sm:h-6 sm:w-6" />;
  }

  return (
    <div
      className="flex h-5 w-5 flex-shrink-0 items-center justify-center sm:h-6 sm:w-6 animate-in fade-in zoom-in-75 duration-300 ease-out"
      role="status"
      aria-live="polite"
      aria-label="Assistant is thinking"
    >
      <div className="relative flex items-center justify-center">
        {/* Outer ripple ring */}
        <div
          className="absolute h-3 w-3 animate-ping rounded-full opacity-30 sm:h-3.5 sm:w-3.5"
          style={{
            backgroundColor: colors.text.grayLightest,
            animationDuration: "1.5s",
          }}
        />
        {/* Inner solid dot */}
        <div
          className="relative h-2 w-2 rounded-full sm:h-2.5 sm:w-2.5"
          style={{
            backgroundColor: colors.text.grayLightest,
          }}
        />
      </div>
    </div>
  );
}
